export enum ActionType {
    SET_LANG_VALUE = "setLangValue",
    SET_NAME = "setName",
    SET_FREEZ_SCREEN = "setFreezScreen",
    SET_ALERT_MESSAGE = "setAlertMessages",
    SET_FORMDATA = "setFormData",
    SET_SHOP_URL = "setShopUrl",
    SET_USER_INFO = "setUserInfo",
    SET_TABLE_LIST = "setTableList",
    SET_TABLE_INVOICE = "setTableInvoice",
    SET_INVOICE_DATA = 'setInvoice',
    SET_BRANCH_DATA = "setBranch",
    SET_LOGIN = 'setLogin',    
    SET_LOGOUT = 'setLogout',
    SET_TABLES_TYPE = 'setTablesType',
    SET_TABLE_INFO = 'setTableInfo',
    SET_CUSTOM_TABLE_SEARCH_MODE = 'setCustomTableSearchMode',
    SET_InvoiceMarkedpopup='invoiceMarkedpopup'
}